import React from "react";
import { useTranslation } from "@helpers/translate";
import "./CopiedPopup.sass";

export const CopiedPopup = ({ show }) => {
  const { __ } = useTranslation();

  if (!show) return null;

  return (
    <div className="profile__copied-popup">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3333 4L6 11.3333L2.66667 8"
          stroke="#4CAF50"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span>{__("common.copied")}</span>
    </div>
  );
};
